import {
  ArrowDownIcon,
  ArticleLabelIcon,
  Cross,
  EditLable,
  PDFDragDropIcon,
  PDFIcon,
  Plus,
  SmallCrossIcon,
  Trash,
  UploadImgIcon,
  Washing_1,
  Washing_10,
  Washing_11,
  Washing_12,
  Washing_2,
  Washing_3,
  Washing_4,
  Washing_5,
  Washing_6,
  Washing_7,
  Washing_8,
  Washing_9,
  XCloseIcon,
} from "assests";
import { Button } from "components/UI/Button";
import CustomSelect from "components/UI/CustomSelect";
import Divider from "components/UI/Divider";
import ErrorMessage from "components/UI/ErrorMessage";
import { Input } from "components/UI/Input";
import { Label } from "components/UI/Label";
import ToasterIcon from "components/UI/ToasterIcon";
import UpgradeComponent from "components/UI/UpgradeComponent";
import useCreateArticle from "hooks/useCreateArticle";
import usePermission from "hooks/usePermission";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { iconComponents } from "utils/fakeData";
import {
  preventMinus,
  preventPasteNegative,
  preventSpaceAndPasteNegative,
  preventSpaceMinus,
  truncateString,
} from "utils/helper";
import ArticleImageCarousel from "./ArticleImageCarousel";

const CreateArticle = ({ closeModal, refetchArticleData, setPage, setActiveTab }) => {
  const { userPermission } = usePermission();
  const { currentWorkspace } = useSelector((state) => state.authenticationSlice);

  const {
    control,
    setValue,
    isDuplicateAction,
    articleDetails,
    articleTypeList,
    compositionList,
    genderList,
    errors,
    isLoading,
    isArticleDetailsLoading,
    isPending,
    isArticleEditable,
    actionableArticelId,
    imagePreviews,
    handleDragEnter,
    handleDragLeave,
    handleDrop,
    onValidationError,
    onFileDropOrChange,
    handleCertFileDelete,
    register,
    reset,
    handleSubmit,
    onSubmit,
    handleAddComposition,
    handleRemoveComposition,
    compositionFormLength,
    templateList,
    handleWashingInstructionKeyDown,
    handleWashingInstructionChange,
    removeWashingInstructionField,
    selectWashingInstructionIcon,
    toggleWashingInstructionDropdown,
    fields,
    dropdownOpenIndex,
    handleEnterKeyPress,
    handleChange,
    setIsIconDropdwonOpen,
    isIconDropdwonOpen,
    setDropdownOpenIndex,
    inputRefs,
    inputWashingRefs,
  } = useCreateArticle({
    refetchArticleData,
    isCreatingArticleFromArticle: true,
    setPage,
    setActiveTab,
  });

  const handleCancel = () => {
    reset();
    closeModal();
  };

  useEffect(() => {
    setValue("washing_instructions", fields);
  }, [fields, setValue]);

  const iconsRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (iconsRef.current && !iconsRef.current.contains(event.target)) {
        setIsIconDropdwonOpen(false);
        setDropdownOpenIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative">
      <div className=" flex items-center justify-center ">
        <div className="w-full lg:w-[688px] max-h-[525px] py-6   rounded-xl bg-white z-[2] ">
          <div className="absolute right-5 top-5 z-[2] cursor-pointer " onClick={handleCancel}>
            <Cross fillColor={"#A4A7AE"} height={24} width={24} />
          </div>
          {isLoading || (actionableArticelId && isArticleDetailsLoading) ? (
            <div className="grid gap-2">
              <div className="flex items-center justify-center w-full h-32 mt-10">
                <div className="border-4 rounded-full w-7 h-7 animate-spin border-global-primary border-t-transparent"></div>
              </div>
              <p className="mt-5 text-center">Preparing form data, please wait...</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit, onValidationError)}>
              <div className="grid grid-cols-1 gap-6">
                <div>
                  <div className="flex justify-start gap-x-4 px-6 z-[1] ">
                    <UpgradeComponent>
                      <ArticleLabelIcon />
                    </UpgradeComponent>

                    <div className="flex justify-between z-[2]">
                      <div className="flex flex-col gap-1">
                        <h2 className="text-sm lg:text-lg  font-semibold text-start text-login-text-title pr-6">
                          {actionableArticelId &&
                            isDuplicateAction &&
                            (articleDetails?.article_title
                              ? truncateString(`${articleDetails?.article_title}`)
                              : "Untitled Article")}
                          {actionableArticelId &&
                            !isDuplicateAction &&
                            (articleDetails?.article_title
                              ? truncateString(`${articleDetails?.article_title}`)
                              : "Untitled Article")}
                          {!actionableArticelId && "New Article"}
                        </h2>
                        <p className="text-xs lg:text-sm leading-5 text-input-text-label font-normal truncate">
                          {actionableArticelId &&
                            articleDetails &&
                            (!isArticleEditable
                              ? truncateString(`${articleDetails?.article_id}`)
                              : truncateString(`${articleDetails?.article_id}`))}
                          {!actionableArticelId && "Add article details here."}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="grid gap-4 px-[21.5px] pt-6 lg:pt-10 h-[303px]  lg:h-[325px] overflow-auto z-[3]">
                    <div className="grid grid-cols-12 gap-1.5 lg:gap-0">
                      <div className="col-span-12 lg:col-span-3">
                        <Label
                          htmlFor="article_title"
                          className="text-sm leading-5 font-medium text-global-paragraph-3"
                        >
                          Article Title
                        </Label>
                      </div>
                      <div className="col-span-12 lg:col-span-9">
                        <div className="grid gap-1.5">
                          <Input
                            id="article_title"
                            type="text"
                            placeholder="Enter title"
                            className={`px-[14px] py-[12.5px] h-11 custom-card text-base font-normal placeholder:text-base leading-[19.36px] text-global-title placeholder:leading-[19.36px] placeholder:text-input-text-placeholder-extra hover:outline-none hover:border hover:border-input-stroke-default`}
                            {...register("article_title")}
                            disabled={!isArticleEditable}
                          />
                          <ErrorMessage errors={errors?.article_title?.message} />
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-12 gap-1.5 lg:gap-0">
                      <div className="col-span-12 lg:col-span-3">
                        <Label
                          htmlFor="article_id"
                          className="text-sm leading-5 font-medium text-global-paragraph-3"
                        >
                          Article ID
                        </Label>
                      </div>
                      <div className="col-span-12 lg:col-span-9">
                        <div className="grid gap-1.5">
                          <Input
                            id="article_id"
                            type="text"
                            placeholder="PW120-100"
                            className={`px-[14px] py-[12.5px] h-11 custom-card text-base font-normal placeholder:text-base leading-[19.36px] text-global-title placeholder:leading-[19.36px] placeholder:text-input-text-placeholder-extra hover:outline-none hover:border hover:border-input-stroke-default`}
                            {...register("article_id")}
                            disabled={!isArticleEditable}
                            onPaste={preventSpaceAndPasteNegative}
                            onKeyPress={preventSpaceMinus}
                          />
                          <ErrorMessage errors={errors?.article_id?.message} />
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-12 gap-1.5 lg:gap-0">
                      <div className="col-span-12 lg:col-span-3">
                        <Label
                          htmlFor="brand"
                          className="text-sm leading-5 font-medium text-global-paragraph-3"
                        >
                          Brand
                        </Label>
                      </div>
                      <div className="col-span-12 lg:col-span-9">
                        <div className="grid gap-1.5">
                          <Input
                            id="brand"
                            type="text"
                            placeholder="Enter brand"
                            className={`px-[14px] py-[12.5px] h-11 custom-card text-base font-normal placeholder:text-base leading-[19.36px] text-global-title placeholder:leading-[19.36px] placeholder:text-input-text-placeholder-extra hover:outline-none hover:border hover:border-input-stroke-default`}
                            {...register("brand")}
                            disabled={!isArticleEditable}
                          />
                          <ErrorMessage errors={errors?.brand?.message} />
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-12 gap-1.5 lg:gap-0">
                      <div className="col-span-12 lg:col-span-3">
                        <Label
                          htmlFor="sku"
                          className="text-sm leading-5 font-medium text-global-paragraph-3"
                        >
                          SKU
                        </Label>
                      </div>
                      <div className="col-span-12 lg:col-span-9">
                        <div className="grid gap-1.5">
                          <Input
                            id="sku"
                            type="text"
                            placeholder="Enter sku"
                            className={`px-[14px] py-[12.5px] h-11 custom-card text-base font-normal placeholder:text-base leading-[19.36px] text-global-title placeholder:leading-[19.36px] placeholder:text-input-text-placeholder-extra hover:outline-none hover:border hover:border-input-stroke-default`}
                            {...register("sku")}
                            disabled={!isArticleEditable}
                            onPaste={preventPasteNegative}
                            onKeyPress={preventMinus}
                          />
                          <ErrorMessage errors={errors?.sku?.message} />
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-12 gap-1.5 lg:gap-0">
                      <div className="col-span-12 lg:col-span-3">
                        <Label
                          htmlFor="description"
                          className="text-sm leading-5 font-medium text-global-paragraph-3"
                        >
                          Description
                        </Label>
                      </div>
                      <div className="col-span-12 lg:col-span-9">
                        <div className="grid gap-1.5">
                          <textarea
                            id="description"
                            name="description"
                            className="flex w-full gap-3 px-3.5 py-3 h-[80px] items-center text-base shadow-[0px,1px,2px,0px,rgba(16,24,40,0.05)] placeholder:text-base leading-[19.36px] text-global-title placeholder:leading-[19.36px] placeholder:text-input-text-placeholder-extra  rounded-lg focus:ring-0 placeholder:font-normal disabled:bg-input-surface-disabled disabled:border-dropdown-stroke-default-2 focus:outline-none  focus:shadow-[none] focus:border-input-stroke-defaul  self-stretch border border-input-stroke-default bg-input-surface-background transition duration-300 ease-in-out read-only:bg-input-surface-hover hover:bg-input-surface-hover hover:outline-none"
                            placeholder="Enter article details for display on the digital product passport if enabled."
                            rows="3"
                            disabled={!isArticleEditable}
                            {...register("description")}
                          />
                          <ErrorMessage errors={errors?.description?.message} />
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-12 gap-1.5 lg:gap-0">
                      <div className="col-span-12 lg:col-span-3">
                        <Label
                          htmlFor="article_type"
                          className="text-sm leading-5 font-medium text-global-paragraph-3"
                        >
                          Article Type
                        </Label>
                      </div>
                      <div className="col-span-12 lg:col-span-9">
                        <div className="grid gap-1.5">
                          <CustomSelect
                            control={control}
                            name="article_type"
                            placeholder="Select type"
                            options={articleTypeList}
                            isClearable={false}
                            isDisabled={!isArticleEditable}
                            style={{
                              padding: "3.5px 10px 7px 1.5px",
                              fontSize: "16px",
                              color: "var(--color-global-title)",
                              placeHolderColor: "var(--color-input-text-placeholder-extra)",
                            }}
                            {...register("article_type")}
                          />
                          <ErrorMessage errors={errors?.article_type?.message} />
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-12 gap-1.5 lg:gap-0">
                      <div className="col-span-12 lg:col-span-3">
                        <Label
                          htmlFor="gender_id"
                          className="text-sm leading-5 font-medium text-global-paragraph-3"
                        >
                          Sex
                        </Label>
                      </div>
                      <div className="col-span-12 lg:col-span-9">
                        <div className="grid gap-1.5">
                          <CustomSelect
                            control={control}
                            name="gender_id"
                            placeholder="Select gender"
                            options={genderList}
                            isDisabled={!isArticleEditable}
                            {...register("gender_id")}
                            isClearable={false}
                            style={{
                              padding: "3.5px 10px 7px 1.5px",
                              fontSize: "16px",
                              color: "var(--color-global-title)",
                              placeHolderColor: "var(--color-input-text-placeholder-extra)",
                            }}
                          />
                          <ErrorMessage errors={errors?.gender_id?.message} />
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-12 gap-1.5 lg:gap-0">
                      <div className="col-span-12 lg:col-span-3">
                        <div className="flex flex-row gap-2">
                          <Label className="text-sm leading-5 font-medium text-global-paragraph-3">
                            Composition
                          </Label>
                          {/* {isArticleEditable && (
                            <Button
                              type="button"
                              size="sm"
                              className="p-[5px] rounded-full"
                              onClick={handleAddComposition}
                            >
                              <Plus
                                width={10}
                                height={10}
                                fillColor={"var(--color-icon-fill-light)"}
                              />
                            </Button>
                          )} */}
                        </div>
                      </div>
                      <div className="col-span-12 lg:col-span-9">
                        <div className="grid gap-1.5">
                          <div className="flex flex-col gap-4">
                            {[...Array(compositionFormLength)].map((_, index) => (
                              <div className="w-full flex flex-col gap-1.5 group">
                                <div
                                  key={index}
                                  className="flex flex-row  justify-start   gap-x-2 w-full rounded-lg"
                                >
                                  <div className="flex justify-start  w-full rounded-lg">
                                    <div className="flex flex-col gap-1.5 text-wrap">
                                      <input
                                        className="text-center h-11 w-[57px] border border-r-0 border-input-stroke-default disabled:bg-input-surface-disabled disabled:border-dropdown-stroke-default-2 focus:outline-none focus:border-input-stroke-default focus:ring-0 custom-card  placeholder:text-base placeholder:text-input-text-placeholder-extra rounded-l-md"
                                        type="number"
                                        min="0"
                                        max="100"
                                        step="0.1"
                                        placeholder="0%"
                                        disabled={!isArticleEditable}
                                        name={`percentage.${index}`}
                                        onPaste={preventPasteNegative}
                                        onKeyPress={preventMinus}
                                        {...register(`percentage.${index}`, {
                                          valueAsNumber: true,
                                        })}
                                        ref={(el) => {
                                          register(`percentage.${index}`).ref(el);
                                          if (el) inputRefs.current[index] = el;
                                        }}
                                        onChange={(e) => handleChange(e, index)}
                                        onKeyDown={(e) => handleEnterKeyPress(e, index)}
                                      />
                                    </div>

                                    <div className="flex-1 flex-grow w-full">
                                      <div className="flex flex-col gap-1.5">
                                        <CustomSelect
                                          control={control}
                                          name={`compositions-${index}`}
                                          placeholder="Select composition"
                                          options={compositionList}
                                          isDisabled={!isArticleEditable}
                                          {...register(`compositions.${index}`)}
                                          style={{
                                            padding: "3.5px 10px 7px 1.5px",
                                            fontSize: "16px",
                                            borderRadius: "0px 6px 6px 0px",
                                            color: "var(--color-global-title)",
                                            textTransform: "none",
                                            placeHolderColor:
                                              "var(--color-input-text-placeholder-extra)",
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  {isArticleEditable &&
                                    compositionFormLength > 1 &&
                                    index !== 0 && (
                                      <button
                                        type="button"
                                        onClick={() => handleRemoveComposition(index)}
                                        className="hidden group-hover:block transition-opacity duration-200"
                                      >
                                        <XCloseIcon width={20} height={20} />
                                      </button>
                                    )}
                                </div>
                                <div className="flex justify-between gap-2">
                                  {errors?.percentage?.length > 0 && errors.percentage[index] && (
                                    <div className="flex w-full justify-start">
                                      <ErrorMessage errors={errors?.percentage[index]?.message} />
                                    </div>
                                  )}

                                  {errors?.compositions?.length > 0 &&
                                    errors.compositions[index] && (
                                      <div className="flex w-full justify-end">
                                        <ErrorMessage
                                          errors={errors?.compositions[index]?.message}
                                        />
                                      </div>
                                    )}
                                </div>
                              </div>
                            ))}
                          </div>

                          {errors?.sum && (
                            <p className="text-sm leading-5 text-global-paragraph font-normal whitespace-nowrap">
                              The total percentage must equal 100%.
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-12 gap-1.5 lg:gap-0">
                      <div className="col-span-12 lg:col-span-3">
                        <Label
                          htmlFor="template_id"
                          className="text-sm leading-5 font-medium text-global-paragraph-3"
                        >
                          Supply Chain
                        </Label>
                      </div>
                      <div className="col-span-12 lg:col-span-9">
                        <div className="grid gap-1.5">
                          <CustomSelect
                            control={control}
                            name="template_id"
                            placeholder="Select template"
                            options={templateList}
                            isClearable={false}
                            isDisabled={!isArticleEditable}
                            style={{
                              padding: "3.5px 10px 7px 1.5px",
                              fontSize: "16px",
                              color: "var(--color-global-title)",
                              placeHolderColor: "var(--color-input-text-placeholder-extra)",
                            }}
                            {...register("template_id")}
                          />
                          <ErrorMessage errors={errors?.template_id?.message} />
                        </div>
                      </div>
                    </div>
                    <Divider />
                    <div className="grid grid-cols-12 gap-1.5 lg:gap-0">
                      <div className="col-span-12 lg:col-span-3">
                        <Label
                          htmlFor="article_image"
                          className="text-sm leading-5 font-medium text-global-paragraph-3"
                        >
                          Article Image
                        </Label>
                      </div>
                      <div className="col-span-12 lg:col-span-9">
                        <div className="grid gap-4">
                          <div className="grid gap-1.5">
                            <div className="flex flex-col md:flex-row gap-3 items-center group justify-center md:items-start md:justify-start lg:gap-5">
                              <div
                                className={`w-full  relative rounded-xl h-[74px] ring-1 ring-inset  ${isArticleEditable ? "ring-border-divider-stroke bg-white group-hover:ring-2 group-hover:ring-global-primary" : "bg-input-surface-disabled ring-dropdown-stroke-default-2"}`}
                                onDragOver={handleDragEnter}
                                onDragEnter={handleDragEnter}
                                onDragLeave={handleDragLeave}
                                onDrop={handleDrop}
                              >
                                <div>
                                  <label
                                    htmlFor="dropzone-file"
                                    className={` ${isArticleEditable ? "cursor-pointer" : "cursor-default"}`}
                                  >
                                    <div className="w-full flex-col px-3 md:px-6 py-[17px] justify-start items-center inline-flex">
                                      <div className="w-full flex-col justify-start items-center gap-3 flex">
                                        <div className="flex-col justify-start items-center gap-1 flex">
                                          <div className="justify-center items-start gap-1 md:inline-flex">
                                            <div className="text-global-title text-xs lg:text-sm font-semibold leading-tight text-center md:text-start">
                                              Click to upload
                                            </div>
                                            <div className="text-global-paragraph text-xs lg:text-sm font-normal leading-tight">
                                              or drag and drop
                                            </div>
                                          </div>
                                          <div className="text-center text-global-paragraph text-[10px] lg:text-xs font-normal  leading-[18px]">
                                            image (max. 10mb)
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </label>

                                  <input
                                    id="dropzone-file"
                                    type="file"
                                    className="hidden"
                                    accept=".png,.jpg,.jpeg"
                                    onChange={(e) => onFileDropOrChange(e)}
                                    multiple
                                    disabled={!isArticleEditable}
                                  />
                                </div>
                              </div>
                            </div>
                            <ErrorMessage errors={errors?.cert_files?.message} />
                          </div>

                          {imagePreviews.length > 0 ? (
                            <div className="w-full overflow-hidden">
                              <ArticleImageCarousel
                                imagePreviews={imagePreviews}
                                isArticleEditable={isArticleEditable}
                                handleCertFileDelete={handleCertFileDelete}
                              />
                            </div>
                          ) : (
                            " "
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-12 gap-1.5 lg:gap-0">
                      <div className="col-span-12 lg:col-span-3">
                        <Label
                          htmlFor="washing_instructions"
                          className="text-sm leading-5 font-medium text-global-paragraph-3"
                        >
                          Washing Instructions
                        </Label>
                      </div>
                      <div className="col-span-12 lg:col-span-9">
                        <div className="grid gap-1.5">
                          <div className="flex flex-col gap-4">
                            {fields.map((field, index) => {
                              const SelectedIcon = iconComponents.find(
                                (icon) => icon.id === field.icon,
                              )?.Component;

                              return (
                                <div className="grid gap-1.5" key={index}>
                                  <div className="flex items-center justify-between w-full gap-1.5 group">
                                    <div
                                      key={index}
                                      className={`flex w-full gap-3 h-11 px-[14px] text-base shadow-[0px,1px,2px,0px,rgba(16,24,40,0.05)] focus:shadow-[none] focus:ring-offset-input-surface-background 
                                       focus:border-none focus:ring-input-stroke-default py-[2.5px] items-center placeholder:text-base leading-[19.36px] text-global-title placeholder:leading-[19.36px] placeholder:text-input-text-placeholder-extra  self-stretch border  transition duration-300 ease-in-out rounded-lg   
                                          ${isArticleEditable ? "border-input-stroke-default bg-input-surface-background hover:bg-input-surface-hover hover:outline-none" : "bg-input-surface-disabled border-dropdown-stroke-default-2"}`}
                                    >
                                      <div className="relative" ref={iconsRef}>
                                        <button
                                          type="button"
                                          onClick={() => toggleWashingInstructionDropdown(index)}
                                          className="flex items-center gap-1 overflow-hidden"
                                          disabled={!isArticleEditable}
                                        >
                                          {SelectedIcon && <SelectedIcon width={20} height={20} />}
                                          <ArrowDownIcon strokeColor={"var(--color-global-gray)"} />
                                        </button>

                                        {isIconDropdwonOpen && dropdownOpenIndex === index && (
                                          <div className="absolute z-50 mt-4 left-[-14px] flex flex-wrap gap-4 bg-white border py-5 px-[18px] rounded shadow-[0_5px_12px_rgba(0,0,0,0.1)] w-[408px]">
                                            {iconComponents.map(({ id, Component }) => (
                                              <button
                                                key={id} // ✅ This prevents React warning about missing keys
                                                onClick={() =>
                                                  selectWashingInstructionIcon(index, id)
                                                }
                                                className="w-12 h-12 bg-white flex items-center justify-center hover:bg-gray-200 rounded text-[#344054]"
                                                type="button"
                                              >
                                                <Component />
                                              </button>
                                            ))}
                                          </div>
                                        )}
                                      </div>
                                      <input
                                        type="text"
                                        className="bg-transparent p-0 m-0 flex-1 w-full h-full border-none focus:outline-none focus:ring-0 placeholder:text-base leading-[19.36px] text-global-title placeholder:leading-[19.36px] placeholder:text-input-text-placeholder-extra  self-stretch"
                                        placeholder="Add instruction"
                                        value={field.description}
                                        disabled={!isArticleEditable}
                                        ref={(el) => {
                                          if (el) inputWashingRefs.current[index] = el;
                                        }}
                                        onChange={(e) =>
                                          handleWashingInstructionChange(
                                            index,
                                            "description",
                                            e.target.value,
                                          )
                                        }
                                        onKeyDown={(e) => handleWashingInstructionKeyDown(e, index)}
                                      />
                                    </div>
                                    {isArticleEditable && fields.length > 1 && index !== 0 && (
                                      <button
                                        type="button"
                                        onClick={() => removeWashingInstructionField(index)}
                                        className="hidden group-hover:block transition-opacity duration-200"
                                      >
                                        <XCloseIcon width={20} height={20} />
                                      </button>
                                    )}
                                  </div>
                                  {errors?.washing_instructions?.[index]?.description?.message && (
                                    <ErrorMessage
                                      errors={
                                        errors?.washing_instructions?.[index]?.description?.message
                                      }
                                    />
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="pt-4 lg:pt-8">
                    <Divider />
                  </div>
                </div>
              </div>
              <div className="flex  justify-center items-center lg:justify-between gap-4 pt-4 lg:pt-6 px-6 ">
                {!actionableArticelId &&
                  (!isArticleEditable || isArticleEditable) &&
                  !isDuplicateAction && (
                    <div className="flex flex-col lg:flex-row justify-center  w-full  gap-3 ">
                      <Button
                        type="button"
                        size={"md"}
                        variant={"secondary"}
                        className={
                          "w-full text-txt-secondary-secondary  h-11 px-4 py-2.5 text-base leading-6 font-semibold custom-outline-shadow "
                        }
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                      {userPermission("create_article.can") && (
                        <Button
                          type="submit"
                          size={"md"}
                          className="h-11 px-4 py-2.5 text-base  leading-6 w-full"
                          isDisabled={isPending}
                        >
                          Save Article
                        </Button>
                      )}
                    </div>
                  )}

                {actionableArticelId && isArticleEditable && isDuplicateAction && (
                  <div className="flex flex-col lg:flex-row justify-center w-full  gap-3">
                    <Button
                      type="button"
                      size={"md"}
                      variant={"secondary"}
                      className={
                        "w-full text-txt-secondary-secondary bg-white h-11 px-4 py-2.5 text-base leading-6 font-semibold custom-outline-shadow hover:text-white"
                      }
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                    {userPermission("create_article.can") && (
                      <Button
                        type="submit"
                        size={"md"}
                        className="h-11 px-4 py-2.5 text-base  leading-6 w-full"
                        isDisabled={isPending}
                      >
                        Save Article
                      </Button>
                    )}
                  </div>
                )}

                {actionableArticelId && !isArticleEditable && !isDuplicateAction && (
                  <div className="flex flex-col lg:flex-row justify-center w-full gap-3">
                    <Button
                      type="button"
                      size={"md"}
                      variant={"secondary"}
                      className={
                        "w-full text-txt-secondary-secondary bg-white h-11 px-4 py-2.5 text-base leading-6 font-semibold custom-outline-shadow hover:text-white"
                      }
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  </div>
                )}

                {actionableArticelId && isArticleEditable && !isDuplicateAction && (
                  <div className="flex flex-col lg:flex-row justify-center w-full  gap-3 ">
                    <Button
                      type="button"
                      size={"md"}
                      variant={"secondary"}
                      className={
                        "w-full text-txt-secondary-secondary bg-white h-11 px-4 py-2.5 text-base leading-6 font-semibold custom-outline-shadow hover:text-white"
                      }
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                    {userPermission("update_article.can") && (
                      <Button
                        type="submit"
                        size={"md"}
                        className="h-11 px-4 py-2.5 text-base  leading-6 w-full"
                        isDisabled={isPending}
                      >
                        Save Article
                      </Button>
                    )}
                  </div>
                )}
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateArticle;
